"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _ApplicationInformation = _interopRequireDefault(require("./ApplicationInformation"));
var _PlanInformation = _interopRequireDefault(require("./PlanInformation"));
var _NBTActionButtons = _interopRequireDefault(require("./NBTActionButtons"));
var _constants = require("./constants");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var NBTConfirm = function NBTConfirm(_ref) {
  var id = _ref.id,
    firstName = _ref.firstName,
    lastName = _ref.lastName,
    loanAmount = _ref.loanAmount,
    payment = _ref.payment,
    term = _ref.term,
    rate = _ref.rate,
    employerTooltipMsg = _ref.employerTooltipMsg,
    submitBtnText = _ref.submitBtnText,
    selectPlanRedirect = _ref.selectPlanRedirect,
    submitApplication = _ref.submitApplication,
    formatNumberWithComma = _ref.formatNumberWithComma;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    submitError = _useState2[0],
    setSubmitError = _useState2[1];
  var _useForm = (0, _reactHookForm.useForm)({
      defaultValues: {
        employmentStatusCd: _constants.EMPLOYMENT_STATUS.employed.value,
        employerName: '',
        jobTitle: ''
      }
    }),
    errors = _useForm.formState.errors,
    register = _useForm.register,
    watch = _useForm.watch,
    handleSubmit = _useForm.handleSubmit;
  return /*#__PURE__*/_react.default.createElement("form", {
    className: "nbt-confirm",
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/_react.default.createElement(_ApplicationInformation.default, {
    showEmploymentInfo: watch('employmentStatusCd') === _constants.EMPLOYMENT_STATUS.employed.value,
    applicantName: "".concat(firstName, " ").concat(lastName),
    employerTooltip: employerTooltipMsg,
    errors: errors,
    register: register
  }), /*#__PURE__*/_react.default.createElement(_PlanInformation.default, {
    loanAmount: loanAmount,
    payment: payment,
    term: term,
    rate: rate,
    formatNumberWithComma: formatNumberWithComma
  }), /*#__PURE__*/_react.default.createElement(_NBTActionButtons.default, {
    showError: submitError,
    submitBtnText: submitBtnText,
    selectPlanRedirect: selectPlanRedirect
  }));
  function onSubmit(values) {
    if (!submitApplication || typeof submitApplication !== 'function') {
      setSubmitError(true);
      return;
    }
    var params = _objectSpread({}, values);
    if (params.employmentStatusCd !== _constants.EMPLOYMENT_STATUS.employed.value) {
      delete params.employerName;
      delete params.jobTitle;
    }
    params.id = id;
    params.partialChange = false;
    params.acceptPost = true;
    submitApplication(params);
  }
};
NBTConfirm.propTypes = {
  id: _propTypes.default.string.isRequired,
  firstName: _propTypes.default.string.isRequired,
  lastName: _propTypes.default.string.isRequired,
  loanAmount: _propTypes.default.number.isRequired,
  payment: _propTypes.default.number.isRequired,
  term: _propTypes.default.number.isRequired,
  rate: _propTypes.default.number.isRequired,
  employerTooltipMsg: _propTypes.default.string.isRequired,
  submitBtnText: _propTypes.default.string.isRequired,
  selectPlanRedirect: _propTypes.default.string.isRequired,
  submitApplication: _propTypes.default.func.isRequired,
  formatNumberWithComma: _propTypes.default.func.isRequired
};
var _default = NBTConfirm;
exports.default = _default;
